module.exports = __webpack_public_path__ + "img/collection-weddingRingsDiamonds@2x.9f01e9a.jpg";